import { useEffect, useRef } from "react";

import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";

import { withRouter } from "../../../shared/utility";

import EmptyModal from "../../../components/modals/EmptyModal";
import { PalletLetDownViewModel } from "../../../viewmodels/inventory/palletLetDown/PalletLetDownViewModel";

function PalletLetDownScreen(props) {
  const { logout, addSnackbar } = props;

  const {
    palletPayload,
    palletScanInput,
    setPalletScanInput,
    cartonScanInput,
    setCartonScanInput,
    sessionLetDowns,
    palletFetchInProgress,
    cartonLetDownInProgress,
    emptyModal,
    setEmptyModelOpen,
    fetchPalletByBarcode,
    letDownCarton,
    resetPallet,
  } = PalletLetDownViewModel(logout, addSnackbar);

  const palletInputRef = useRef(null);
  const cartonInputRef = useRef(null);

  useEffect(() => {
    palletInputRef.current?.focus();
  }, []);

  useEffect(() => {
    if (palletPayload) {
      cartonInputRef.current?.focus();
    } else {
      palletInputRef.current?.focus();
    }
  }, [palletPayload]);

  const pi = palletPayload?.packaged_item;

  return (
    <div className="mt-2 pl-0 sm:px-4">
      <div className="sm:flex-auto">
        <h1 className="text-xl font-semibold leading-6 text-gray-900">
          Pallet let down
        </h1>
        <p className="mt-1 text-sm text-gray-500">
          Scan a pallet, then scan cartons to remove from the pallet.
        </p>
      </div>

      <div className="mt-6 space-y-6">
        {!palletPayload ? (
          <div className="card-custom p-4">
            <label
              htmlFor="pallet_barcode_scan"
              className="text-sm block font-medium text-gray-900"
            >
              Scan pallet
            </label>
            <input
              id="pallet_barcode_scan"
              placeholder="Scan pallet barcode"
              name="pallet_barcode_scan"
              disabled={palletFetchInProgress}
              ref={palletInputRef}
              value={palletScanInput}
              onChange={(e) => setPalletScanInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchPalletByBarcode(e.target.value);
                }
              }}
              type="search"
              autoComplete="off"
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />
          </div>
        ) : null}

        {palletPayload && pi ? (
          <div className="card-custom p-4 space-y-3">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
              <h2 className="text-sm font-semibold text-gray-900">
                Pallet information
              </h2>
              <button
                type="button"
                className="inline-flex shrink-0 justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:ml-4"
                onClick={resetPallet}
              >
                Reset / new pallet
              </button>
            </div>
            <dl className="grid grid-cols-1 gap-2 text-sm sm:grid-cols-2">
              <div>
                <dt className="text-gray-500">Barcode</dt>
                <dd className="font-medium text-gray-900">
                  {palletPayload.barcode ?? pi.barcode}
                </dd>
              </div>
              <div>
                <dt className="text-gray-500">Product name</dt>
                <dd className="font-medium text-gray-900">{pi.product_name}</dd>
              </div>
              <div>
                <dt className="text-gray-500">Brand</dt>
                <dd className="font-medium text-gray-900">{pi.brand_name}</dd>
              </div>
              <div>
                <dt className="text-gray-500">Carton count</dt>
                <dd className="font-medium text-gray-900">{pi.carton_count}</dd>
              </div>
              <div className="sm:col-span-2">
                <dt className="text-gray-500">Description</dt>
                <dd className="font-medium text-gray-900">{pi.description_en}</dd>
              </div>
            </dl>
          </div>
        ) : null}
      </div>

      {palletPayload ? (
        <div className="mt-6 card-custom p-4">
          <label
            htmlFor="carton_barcode_scan"
            className="text-sm block font-medium text-gray-900"
          >
            Scan cartons to let down
          </label>
          <input
            id="carton_barcode_scan"
            placeholder="Scan carton barcode"
            name="carton_barcode_scan"
            disabled={cartonLetDownInProgress}
            ref={cartonInputRef}
            value={cartonScanInput}
            onChange={(e) => setCartonScanInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                letDownCarton(e.target.value);
              }
            }}
            type="search"
            autoComplete="off"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
          />

          {sessionLetDowns.length > 0 ? (
            <div className="mt-4">
              <h3 className="text-sm font-semibold text-gray-900 mb-2">
                Let down this session
              </h3>
              <ul className="divide-y divide-gray-200 border border-gray-200 rounded-md max-h-64 overflow-y-auto">
                {sessionLetDowns.map((row, idx) => (
                  <li
                    key={`${row.barcode}-${row.at}-${idx}`}
                    className="px-3 py-2 text-sm flex justify-between gap-2"
                  >
                    <span className="font-medium text-gray-900">
                      {row.barcode}
                    </span>
                    <span className="text-gray-500 shrink-0">{row.message}</span>
                  </li>
                ))}
              </ul>
            </div>
          ) : null}
        </div>
      ) : null}

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PalletLetDownScreen),
);
